import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function ClassicRanking() {
  const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            欧美经典大片<span className="text-accent-500">排行</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            基于全球影迷评分的经典欧美大片排行榜
          </p>
        </div>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {topRated.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                index < topRated.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>
              <div className="w-12 h-16 md:w-14 md:h-20 flex-shrink-0 rounded overflow-hidden">
                <img src={movie.image} alt={movie.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 line-clamp-1">{movie.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{movie.titleEn} · {movie.year}</p>
                <p className="text-xs text-foreground-600 mt-1 line-clamp-1 hidden sm:block">{movie.director}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 hidden sm:inline-block">
                  {movie.categoryName}
                </span>
                <span className="text-sm md:text-base font-bold text-primary-500">{movie.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}